import React from "react";
import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";

import RootLayout from "./layouts/RootLayout/RootLayout";
import ProtectedRoute from "./auth/ProtectedRoute";

import Home from "./pages/Home";
import Login from "./pages/Login";
import TaskList from "./pages/TaskList";
import ChatRoom from "./pages/ChatRoom";
import Reports from "./pages/Reports";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<RootLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/task-list" element={<TaskList />} />
          <Route path="/chatroom" element={<ChatRoom />} />
          <Route path="/chatroom/:username" element={<ChatRoom />} />
          <Route path="/reports" element={<Reports />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
